// extracted by mini-css-extract-plugin
export default {"FullHeightBody":"NavBarLayout_FullHeightBody__Jptlk","PageContent":"NavBarLayout_PageContent__kbMgN"};